import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5879c34b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full min-h-screen flex flex-col clear-both" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "text-md" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "bullets my-8" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col items-center flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/chemist.png",
    alt: "Magnets with fridge",
    class: "px-20 md:px-4"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              innerHTML: _ctx.$t('alternativeSupply.title'),
              class: "mb-8 font-space text-medium font-bold text-xl"
            }, null, 8, _hoisted_4),
            _createElementVNode("p", {
              innerHTML: _ctx.$t('alternativeSupply.text1'),
              class: "mt-4 text-justify"
            }, null, 8, _hoisted_5),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", {
                innerHTML: _ctx.$t('alternativeSupply.bullet1'),
                class: "mt-1.5 font-bold"
              }, null, 8, _hoisted_7),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('alternativeSupply.bullet2'),
                class: "mt-1 font-bold"
              }, null, 8, _hoisted_8),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('alternativeSupply.bullet3'),
                class: "mt-1 font-bold"
              }, null, 8, _hoisted_9),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('alternativeSupply.bullet4'),
                class: "mt-1 font-bold"
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("p", {
              innerHTML: _ctx.$t('alternativeSupply.text2'),
              class: "mt-4 text-justify"
            }, null, 8, _hoisted_11)
          ]),
          _hoisted_12
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ]))
}